import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {ExpiringWellnessCredits} from './ExpiringWellnessCredits';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(ExpiringWellnessCredits);
